import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
import mainReducer from './mainReducer';
import authReducer from './auth';
import courseReducer from './coursePost';
import getCourses from './courseGet';
import allUsers from './allUsers';
import allPosts from './allPosts';
import cards from './cards';
import playlistReducer from './playlist';
import postReducer from './uploadPost'
import getMedia from './mediaGet'
import ppContents from './ppcontents'
import tcContents from './tccontents'

const rootReducer = combineReducers({
  auth: authReducer,
  course: courseReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  mainReducer,
  getCourses,
  getMedia,
  allUsers,
  cards,
  playlistReducer,
  post: postReducer,
  allPosts,
  ppContents,
  tcContents
});

export default rootReducer;
